import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, Flower2 } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { clearCheckoutDraft } from "../lib/checkoutStorage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResumeOrderPage() {
  const { orderId } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { addToCart, clearCart } = useCart();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/orders/${orderId}/resume`, { params: { t: params.get("t") || "" } });
        if (data.paid) { navigate(data.track_path, { replace: true }); return; }
        await clearCart();
        for (const it of data.items) await addToCart(it.product_id, it.quantity, it.size);
        clearCheckoutDraft();
        sessionStorage.setItem("checkout_prefill", JSON.stringify(data.prefill));
        navigate("/checkout", { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Non siamo riusciti a recuperare l'ordine.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return (
    <div className="min-h-screen flex items-center justify-center py-16 px-6 bg-cream" data-testid="resume-order-page">
      <div className="text-center max-w-md">
        {error ? (
          <>
            <Flower2 className="h-14 w-14 text-sage-light mx-auto mb-4" />
            <h1 className="text-2xl font-serif text-forest mb-2">{error}</h1>
            <p className="text-sage mb-6">Puoi comunque ricominciare da capo: ci vogliono due minuti.</p>
            <Link to="/shops" className="inline-block bg-brand text-white px-6 py-3 rounded-full hover:bg-brand-dark" data-testid="resume-order-browse">Invia Fiori</Link>
          </>
        ) : (
          <>
            <Loader2 className="h-14 w-14 text-forest mx-auto mb-4 animate-spin" />
            <h1 className="text-2xl font-serif text-forest mb-2">Stiamo recuperando il tuo ordine…</h1>
            <p className="text-sage">Fiori, destinatario e data: tutto come lo avevi lasciato.</p>
          </>
        )}
      </div>
    </div>
  );
}
